export default __webpack_public_path__ + "static/media/Skup Pula (5).ee50dd7a.JPG";